"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PensionDashboard = _interopRequireDefault(require("./PensionDashboard"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _PensionDashboard["default"];
exports["default"] = _default;